import ThemeDefinition from '@/ui-kit/domain/ThemeDefinition';
import DOMPurify from 'dompurify';
import { HtmlBlockState } from './HtmlBlockState';

interface Props {
  state: HtmlBlockState;
}

export const HtmlBlockUIElement = ({ state }: Props) => {
  return (
    <div
      className={ThemeDefinition.htmlBlock.root}
      data-element-id={state.viewElement.id}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.html) }}
    />
  );
};
